var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder (2) 1",
    clipPath: "url(#clip0_1371_2712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.675781 17.3274H41.3207V38.3272H0.675781V17.3274Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.3225 39.0046H0.677564C0.303121 39.0046 0 38.7011 0 38.3271V17.3272C0 16.9528 0.303121 16.6497 0.677564 16.6497H41.3225C41.6965 16.6497 42.0001 16.9528 42.0001 17.3272V38.3271C42.0001 38.7011 41.6965 39.0046 41.3225 39.0046ZM1.35474 37.6495H40.6453V18.0044H1.35474V37.6495Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.6112 6.48868H15.9175L14.9015 3.77881H2.55614C1.5177 3.77881 0.675781 4.62072 0.675781 5.65955V30.198C0.675781 31.6946 1.88865 32.9079 3.38526 32.9079H38.6112C40.1078 32.9079 41.3207 31.6946 41.3207 30.198V9.19816C41.3207 7.70155 40.1078 6.48868 38.6112 6.48868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.613 33.5853H3.38704C1.51948 33.5853 0 32.0654 0 30.1978V5.65938C0 4.24844 1.14736 3.10107 2.55792 3.10107H14.9033C15.1859 3.10107 15.4382 3.27667 15.5375 3.54103L16.3887 5.81094H38.613C40.4802 5.81094 42.0001 7.33042 42.0001 9.19799V30.1978C42.0001 32.0654 40.4802 33.5853 38.613 33.5853ZM2.55792 4.4562C1.8947 4.4562 1.35474 4.99616 1.35474 5.65938V30.1978C1.35474 31.3188 2.26643 32.2301 3.38704 32.2301H38.613C39.7336 32.2301 40.6453 31.3188 40.6453 30.1978V9.19799C40.6453 8.07737 39.7336 7.16568 38.613 7.16568H15.9193C15.6367 7.16568 15.3843 6.99048 15.2851 6.72612L14.4339 4.4562H2.55792Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.675781 14.6174H41.3207V35.6177H0.675781V14.6174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.3225 36.2949H0.677564C0.303121 36.2949 0 35.9918 0 35.6177V14.6175C0 14.2434 0.303121 13.9399 0.677564 13.9399H41.3225C41.6965 13.9399 42.0001 14.2434 42.0001 14.6175V35.6177C42.0001 35.9918 41.6965 36.2949 41.3225 36.2949ZM1.35474 34.9402H40.6453V15.2951H1.35474V34.9402Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.70881 23.4238C2.33437 23.4238 2.03125 23.1207 2.03125 22.7466V16.6497C2.03125 16.2757 2.33437 15.9722 2.70881 15.9722C3.08287 15.9722 3.38599 16.2757 3.38599 16.6497V22.7466C3.38599 23.1207 3.08287 23.4238 2.70881 23.4238Z",
    fill: "#6E81E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09375 10.5527H35.9V14.6173H6.09375V10.5527Z",
    fill: "#6E81E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.9018 15.2951H6.09553C5.72148 15.2951 5.41797 14.9916 5.41797 14.6175V10.5529C5.41797 10.1789 5.72148 9.87573 6.09553 9.87573H35.9018C36.2758 9.87573 36.5793 10.1789 36.5793 10.5529V14.6175C36.5793 14.9916 36.2758 15.2951 35.9018 15.2951ZM6.77271 13.94H35.2246V11.2305H6.77271V13.94Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.3227 30.8755H9.67756C9.30351 30.8755 9 30.5724 9 30.1979C9 29.8239 9.30351 29.5208 9.67756 29.5208H29.3227C29.6967 29.5208 30.0002 29.8239 30.0002 30.1979C30.0002 30.5724 29.6967 30.8755 29.3227 30.8755Z",
    fill: "#2B2A63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.3332 27.3551H9.6668C9.29869 27.3551 9 27.0516 9 26.6776C9 26.3035 9.29869 26 9.6668 26H32.3332C32.7013 26 33 26.3035 33 26.6776C33 27.0516 32.7013 27.3551 32.3332 27.3551Z",
    fill: "#2B2A63"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.8686 36.2348C33.4945 36.2348 33.1914 35.9313 33.1914 35.5572V32.8477C33.1914 32.4733 33.4945 32.1702 33.8686 32.1702C34.2426 32.1702 34.5461 32.4733 34.5461 32.8477V35.5572C34.5461 35.9313 34.2426 36.2348 33.8686 36.2348Z",
    fill: "#6E81E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M35.2234 34.88H32.5135C32.1394 34.88 31.8359 34.5765 31.8359 34.2025C31.8359 33.8284 32.1394 33.5249 32.5135 33.5249H35.2234C35.5974 33.5249 35.9005 33.8284 35.9005 34.2025C35.9005 34.5765 35.5974 34.88 35.2234 34.88Z",
    fill: "#6E81E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_2712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder1);
export default __webpack_public_path__ + "static/media/folder-1.d8523ed6e5d2f71fb92f6f648f779730.svg";
export { ForwardRef as ReactComponent };